import { render, staticRenderFns } from "./LmReviewersGroups.vue?vue&type=template&id=2bad16e6"
import script from "./LmReviewersGroups.vue?vue&type=script&lang=js"
export * from "./LmReviewersGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports